import Notfound from "features/notFound/NotFound";
import { ComponentType, FC, lazy, LazyExoticComponent } from "react";
import { MobileDataService } from "utils/enums/MobileDataEnums";
import { TypeOfSupportEnum } from "utils/enums/TypeOfSupportEnum";
import { IModuleInjection } from "app/di/DependencyInjections";
import { SupplierManagementInjection } from "features/supplierManagement/di/SupplierManagmentInjection";
import { AirTimeRegistrationInjection } from "features/airTimeRegistration/di/AirTimeRegistrationInjection";
import { BalanceRegistrationInjection } from "features/balanceRegistration/di/BalanceRegistrationInjection";
import { CashFlowInjection } from "features/cashFlow/di/CashFlowInjection";
import { MobiSimRegistrationInjection } from "features/mobiSimRegistration/di/MobiSimRegistrationInjection";
import { NiceSimRegistrationInjection } from "features/niceSimRegistration/di/NiceSimRegistrationInjection";
import { PackageRegistrationInjection } from "features/packageRegistration/di/PackageRegistrationInjection";
import { ErrorCodeGeneralInjection } from "features/errorCodeGeneralFeature/di/ErrorCodeGeneralInjection";
import { PermissionDataInjection } from "features/permissionDataManagement/di/PermissionDataInjection";
import { RoleManagementInjection } from "features/roleManagement/di/RoleManagementInjection";
import { UserPermissionInjection } from "features/userPermissionManagement/di/UserPermissionInjection";
import { CapabilityInjection } from "features/capabilityManagement/di/CapabilityInjection";
import { ActionLogInjection } from "features/actionLogManagement/di/ActionLogInjection";
import { AirtimeManagementInjection } from "features/airTimeManagement/di/AirtimeManagementInjection";
import { ApiDocumentInjection } from "features/apiDocumentFeature/di/ApiDocumentInjection";
import { AppFeedbackInjection } from "features/appFeedback/di/AppFeedbackInjection";
import { AppProfileInjection } from "features/appProfileRegister/di/AppProfieInjection";
import { BalanceHistoryInjection } from "features/balanceHistory/di/BalanceHistoryInjection";
import { CdnConfigInjection } from "features/cdnConfiguration/di/CdnConfigInjection";
import { CountryConfigInjection } from "features/countryConfiguration/di/CountryConfigInjection";
import { DiscountManagementInjection } from "features/discountManagement/di/DiscountManagementInjection";
import { DistrictConfigurationInjection } from "features/districtConfiguration/di/DistrictConfigurationInjection";
import { IOTSimListLookupInjection } from "features/iotSimListLookup/di/IOTSimListLookupInjection";
import { ManageConfigInjection } from "features/manageConfig/di/ManageConfigInjection";
import { OfficialDispatchInjection } from "features/officialDispatch/di/OfficialDispatchInjection";
import { PackageLookupInjection } from "features/packageLookup/di/PackageLookupInjection";
import { PackageManagementInjection } from "features/packageManagement/di/PackageManagementInjection";
import { PartnerManagementInjection } from "features/partnerManagement/di/PartnerManagementInjection";
import { ProvinceConfigurationInjection } from "features/provinceConfiguration/di/ProvinceConfigurationInjection";
import { SimLookupInjection } from "features/simStatusLookup/di/SimLookupInjection";
import { StoreInjection } from "features/storeManagement/di/StoreInjection";
import { SystemUserInjection } from "features/systemUserManagement/di/SystemUserInjection";
import { VnskySupportAlertInjection } from "features/vnskySupportAlert/di/VnskySupportAlertInjection";
import { VnskySupportOcsInfoInjection } from "features/vnskySupportOcsInfo/di/VnskySupportOcsInfoInjection";
import { WardConfigurationInjection } from "features/wardConfiguration/di/WardConfigurationInjection";

export interface IAppPages {
  Component: LazyExoticComponent<FC<any> | ComponentType>;
  token?: symbol | string;
  injectionModule?: IModuleInjection;
  addtionalProps?: unknown;
}

class AppPages {
  static PageKeys: Record<string, IAppPages> = {
    GeneralFeature: {
      Component: lazy(
        () => import("features/generals/presentation/views/GeneralFeature"),
      ),
    },
    ErrorCodeGeneralFeature: {
      Component: lazy(
        () =>
          import("features/errorCodeGeneralFeature/presentation/views/ErrorCodeGeneralFeature"),
      ),
      injectionModule: ErrorCodeGeneralInjection,
    },
    AppSimMobifoneFeature: {
      Component: lazy(
        () =>
          import("features/mobiSimRegistration/presentation/views/MobiSimRegistrationFeature"),
      ),
      injectionModule: MobiSimRegistrationInjection,
    },
    AirTimeManagementFeature: {
      Component: lazy(
        () =>
          import("features/airTimeManagement/presentation/views/AirTimeManagementFeature"),
      ),
      injectionModule: AirtimeManagementInjection,
    },
    AirTimeRegistrationFeature: {
      Component: lazy(
        () =>
          import("features/airTimeRegistration/presentation/views/AirTimeRegistrationFeature"),
      ),
      injectionModule: AirTimeRegistrationInjection,
    },
    BalanceRegistrationFeature: {
      Component: lazy(
        () =>
          import("features/balanceRegistration/presentation/views/BalanceRegistrationFeature"),
      ),
      injectionModule: BalanceRegistrationInjection,
    },
    AppDataRegisterFeature: {
      Component: lazy(
        () =>
          import("features/packageRegistration/presentation/views/PackageRegistrationFeature"),
      ),
      injectionModule: PackageRegistrationInjection,
    },
    AppNiceSimFeature: {
      Component: lazy(
        () =>
          import("features/niceSimRegistration/presentation/views/NiceSimRegistrationFeature"),
      ),
      injectionModule: NiceSimRegistrationInjection,
    },
    BalanceHistoryFeature: {
      Component: lazy(
        () =>
          import("features/balanceHistory/presentation/view/BalanceHistoryFeature"),
      ),
      injectionModule: BalanceHistoryInjection,
    },
    TravelSimRegistrationManagementFeature: {
      Component: lazy(
        () =>
          import("features/travelSimRegistration/presentation/views/mainVews/TravelSimRegistrationManagementFeature"),
      ),
    },
    CashFlowFeature: {
      Component: lazy(
        () => import("features/cashFlow/presentation/views/CashFlowFeature"),
      ),
      injectionModule: CashFlowInjection,
    },
    PackageLookupFeature: {
      Component: lazy(
        () =>
          import("features/packageLookup/presentation/view/PackageLookupFeature"),
      ),
      injectionModule: PackageLookupInjection,
    },
    SimLookupFeature: {
      Component: lazy(
        () =>
          import("features/simStatusLookup/presentation/view/SimLookupFeature"),
      ),
      injectionModule: SimLookupInjection,
    },
    ApiDocManagementFeature: {
      Component: lazy(
        () =>
          import("features/apiDocumentFeature/presentation/view/ApiDocumentFeature"),
      ),
      injectionModule: ApiDocumentInjection,
      addtionalProps: TypeOfSupportEnum.apiDoc,
    },
    DispatchManagementFeature: {
      Component: lazy(
        () =>
          import("features/officialDispatch/presentation/view/OfficialDispatchFeature"),
      ),
      injectionModule: OfficialDispatchInjection,
      addtionalProps: TypeOfSupportEnum.officialDispatch,
    },
    VnskySupportOcsInfoFeature: {
      Component: lazy(
        () =>
          import("features/vnskySupportOcsInfo/presentation/view/VnskySupportOcsInfoFeature"),
      ),
      injectionModule: VnskySupportOcsInfoInjection,
    },
    VnskySupportAlertFeature: {
      Component: lazy(
        () =>
          import("features/vnskySupportAlert/presentation/view/VnskySupportAlertFeature"),
      ),
      injectionModule: VnskySupportAlertInjection,
    },
    StoreManagementFeature: {
      Component: lazy(
        () =>
          import("features/storeManagement/presentation/view/StoreManagementFeature"),
      ),
      injectionModule: StoreInjection,
    },
    PackageManagementFeature: {
      Component: lazy(
        () =>
          import("features/packageManagement/presentation/view/PackageManagementFeature"),
      ),
      injectionModule: PackageManagementInjection,
      addtionalProps: {
        service: MobileDataService.BuyPackage,
        categoriesForQuery: "",
      },
    },
    DiscountManagementFeature: {
      Component: lazy(
        () =>
          import("features/discountManagement/presentation/view/DiscountManagementView"),
      ),
      injectionModule: DiscountManagementInjection,
    },
    AppProfileRegisterFeature: {
      Component: lazy(
        () =>
          import("features/appProfileRegister/presentation/view/AppProfileRegisterView"),
      ),
      injectionModule: AppProfileInjection,
    },
    AppFeedbackFeature: {
      Component: lazy(
        () =>
          import("features/appFeedback/presentation/views/AppFeedbackFeature"),
      ),
      injectionModule: AppFeedbackInjection,
    },
    SystemUsersManagementFeature: {
      Component: lazy(
        () =>
          import("features/systemUserManagement/presentation/view/SystemUserView"),
      ),
      injectionModule: SystemUserInjection,
    },
    B2CUserManagementFeature: {
      Component: lazy(
        () =>
          import("features/b2cUserManagement/presentation/views/B2CUserManagementFeature"),
      ),
    },
    PartnerManagementFeature: {
      Component: lazy(
        () =>
          import("features/partnerManagement/presentation/views/B2CPartnerManagementFeature"),
      ),
      injectionModule: PartnerManagementInjection,
    },
    SupplierManagementFeature: {
      Component: lazy(
        () =>
          import("features/supplierManagement/presentation/views/SupplierManagementFeature"),
      ),
      injectionModule: SupplierManagementInjection,
    },
    B2BPackageManagementFeature: {
      Component: lazy(
        () =>
          import("features/packageManagement/b2bPackageManagement/presentation/view/B2BPackageManagementFeature"),
      ),
    },
    ProvinceConfigurationFeature: {
      Component: lazy(
        () =>
          import("features/provinceConfiguration/presentation/view/ProvinceConfigurationFeature"),
      ),
      injectionModule: ProvinceConfigurationInjection,
    },
    WardConfigurationFeature: {
      Component: lazy(
        () =>
          import("features/wardConfiguration/presentation/view/WardConfigurationFeature"),
      ),
      injectionModule: WardConfigurationInjection,
    },
    DistrictConfigurationFeature: {
      Component: lazy(
        () =>
          import("features/districtConfiguration/presentation/view/DistrictConfigurationFeature"),
      ),
      injectionModule: DistrictConfigurationInjection,
    },
    CountryConfigurationFeature: {
      Component: lazy(
        () =>
          import("features/countryConfiguration/presentation/views/CountryConfigurationFeature"),
      ),
      injectionModule: CountryConfigInjection,
    },
    CdnConfigurationFeature: {
      Component: lazy(
        () =>
          import("features/cdnConfiguration/presentation/view/CdnConfigurationView"),
      ),
      injectionModule: CdnConfigInjection,
    },
    ManageConfigFeature: {
      Component: lazy(
        () =>
          import("features/manageConfig/presentation/view/ManageConfigFeature"),
      ),
      injectionModule: ManageConfigInjection,
    },
    PermissionDataFeature: {
      Component: lazy(
        () =>
          import("features/permissionDataManagement/presentation/views/PermissionDataFeature"),
      ),
      injectionModule: PermissionDataInjection,
    },
    CapabilityFeature: {
      Component: lazy(
        () =>
          import("features/capabilityManagement/presentation/views/CapabilityFeature"),
      ),
      injectionModule: CapabilityInjection,
    },
    UserPermissionFeature: {
      Component: lazy(
        () =>
          import("features/userPermissionManagement/presentation/views/UserPermissionFeature"),
      ),
      injectionModule: UserPermissionInjection,
    },
    RoleManagementFeature: {
      Component: lazy(
        () =>
          import("features/roleManagement/presentation/views/RoleManagementFeature"),
      ),
      injectionModule: RoleManagementInjection,
    },
    IOTSimListLookupFeature: {
      Component: lazy(
        () =>
          import("features/iotSimListLookup/presentation/view/IOTSimListLookupView"),
      ),
      injectionModule: IOTSimListLookupInjection,
    },
    ActionLogFeature: {
      Component: lazy(
        () =>
          import("features/actionLogManagement/presentation/views/ActionLogFeature"),
      ),
      injectionModule: ActionLogInjection,
    },
  };

  static getPage(key: string): any {
    return this.PageKeys[key]?.Component || Notfound;
  }

  static getToken(key: string) {
    return this.PageKeys[key]?.token;
  }

  static getAddtionalProps(key: string) {
    return this.PageKeys[key]?.addtionalProps;
  }

  static getInjectionModule(key: string) {
    return this.PageKeys[key]?.injectionModule;
  }
}

export default AppPages;
